import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    // If the modal element exists on connect, initialize Bootstrap
    if (this.element.classList.contains("modal")) {
      this.modalInstance = new bootstrap.Modal(this.element, { backdrop: true })
      this.modalInstance.show()

      // Remove modal from DOM when hidden
      this.element.addEventListener("hidden.bs.modal", () => {
        this.element.remove()
        document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
      }, { once: true })
    }
  }

  close() {
    if (this.modalInstance) {
      this.modalInstance.hide()
    }
  }
}
